import { TILE_SIZE } from "../../constants";
import { Images } from "../../lib/images";
import { BaseLayer, BaseTile } from "./base-layer";
import { ObjectLayer, ObjectTile, getButtonColor, getNormalTileType } from "./object-layer";
// All the types of tiles as far as how they interact with the game physics.
export var PhysicTile;
(function (PhysicTile) {
    PhysicTile[PhysicTile["Empty"] = 0] = "Empty";
    PhysicTile[PhysicTile["Wall"] = 1] = "Wall";
    PhysicTile[PhysicTile["Hole"] = 2] = "Hole";
    PhysicTile[PhysicTile["Death"] = 3] = "Death";
})(PhysicTile || (PhysicTile = {}));
/**
 * 2D array of tiles.
 */
export class Tiles {
    constructor(w, h, level) {
        this.baseLayer = new BaseLayer(w, h);
        this.objectLayer = new ObjectLayer(w, h);
        this.level = level;
    }
    update(dt) {
        this.baseLayer.update(dt);
        this.objectLayer.update(dt);
    }
    render(context) {
        this.baseLayer.render(context, this.level);
        this.objectLayer.render(context, this.level);
    }
    getTileCoord(p, positionInTile) {
        return {
            x: p.x * TILE_SIZE + (TILE_SIZE - 1) * positionInTile.x,
            y: p.y * TILE_SIZE + (TILE_SIZE - 1) * positionInTile.y,
        };
    }
    getTileCoordFromCoord(p, positionInTile) {
        return this.getTileCoord({ x: Math.floor(p.x / TILE_SIZE), y: Math.floor(p.y / TILE_SIZE) }, positionInTile);
    }
    static async preload() {
        await Images.loadImage({ name: "tiles", path: "sprites/" });
    }
    getTile(p) {
        const baseTile = this.baseLayer.getTile(p);
        const objectTile = this.objectLayer.getTile(p);
        const objectButtonColor = getButtonColor(objectTile);
        const normalObjectTile = getNormalTileType(objectTile);
        const colorActive = objectButtonColor != undefined && this.level.buttonState[objectButtonColor];
        if (normalObjectTile == ObjectTile.Spikes && colorActive) {
            return PhysicTile.Death;
        }
        if (normalObjectTile == ObjectTile.Bridge && colorActive) {
            return PhysicTile.Empty;
        }
        if (baseTile == BaseTile.Wall) {
            return PhysicTile.Wall;
        }
        if (baseTile == BaseTile.Hole) {
            return PhysicTile.Hole;
        }
        return PhysicTile.Empty;
    }
    getTileAtCoord(p) {
        return this.getTile({
            x: Math.floor(p.x / TILE_SIZE),
            y: Math.floor(p.y / TILE_SIZE),
        });
    }
}
